import MenuItems from './MenuItems';
import {Stack} from '@mui/material';
import * as React from 'react';
import {useUserInfo} from '../userInfo/hooks/useUserInfo';
import MenuNotConnected from "./MenuNotConnected";
import {useAuthentication} from "../auth/hooks/useAuthentication";

const MenuConnected = () => {
  const {profil, isLoadingProfile} = useUserInfo();
  const {isAuthenticated} = useAuthentication();
  console.log('isLoadingProfile',isLoadingProfile, 'profil', profil);

  if (isAuthenticated && !profil) return null;

  return profil && profil.subscriptionStatus == 'active' ? (
    <Stack direction={'row'} sx={{gap: '5px', justifyContent: 'center'}}>
      <MenuItems
        imageSrc={`/assets/icon/home.png`}
        label={'Accueil'}
        link={''}
      />
      <MenuItems
        imageSrc={`/assets/icon/communauté.png`}
        label={'Communautés'}
        link={'communities'}
      />
      <MenuItems
        imageSrc={`/assets/icon/produit_service.png`}
        label={'Produits et services'}
        link={'product-search'}
      />
      <MenuItems
        imageSrc={`/assets/icon/Etoile.png`}
        label={'Favoris'}
        link={'favorite'}
      />
    </Stack>
  ) : <MenuNotConnected/>
};

export default MenuConnected;
